// Public analytics facade — import from here everywhere in the app.
// The underlying vendor (PostHog) is isolated in ./posthog.
export {
	initAnalytics,
	identifyUser,
	resetAnalytics,
	setCommonProps,
	track,
	trackRevenue,
	getAnalyticsIdentity,
	resolveUserId,
	getPosthog,
} from './posthog'
export { EVENTS } from './events'
